var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcWcagReset = function SvgIcWcagReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1860.000000, -19.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "belka_wcag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1861.32857,19 C1861.89457,19 1862.35971,19.4400261 1862.41247,20.0026642 L1862.41745,20.1095182 L1862.417,21.924 L1862.6095,21.718732 C1862.86105,21.458923 1863.11586,21.2259728 1863.38226,21.0140699 C1865.06305,19.7328039 1867.10451,19.0286731 1869.2477,19.0286731 C1874.66005,19.0286731 1879.04762,23.4994069 1879.04762,29.0143366 C1879.04762,34.5292662 1874.66005,39 1869.2477,39 C1865.12893,39 1861.49291,36.3868582 1860.06969,32.5218024 C1859.85844,31.9480868 1860.14362,31.3084946 1860.70666,31.093233 C1861.2697,30.8779715 1861.8974,31.1685558 1862.10866,31.7422714 C1863.21554,34.7482591 1866.04392,36.7809637 1869.2477,36.7809637 C1873.4573,36.7809637 1876.86986,33.3037263 1876.86986,29.0143366 C1876.86986,24.7249468 1873.4573,21.2477094 1869.2477,21.2477094 C1867.57889,21.2477094 1865.99418,21.7942981 1864.70504,22.7767076 C1864.60822,22.8538039 1864.50976,22.9387775 1864.40977,23.0316566 L1865.28814,23.0346115 C1865.85413,23.0346115 1866.31927,23.4746376 1866.37203,24.0372757 L1866.37702,24.1441297 C1866.37702,24.7208543 1865.94518,25.1948054 1865.393,25.2485688 L1865.28814,25.2536478 L1861.32857,25.2536478 C1860.76258,25.2536478 1860.29744,24.8136217 1860.24468,24.2509837 L1860.23969,24.1441297 L1860.23969,20.1095182 C1860.23969,19.4967482 1860.7272,19 1861.32857,19 Z",
    id: "ic_reset"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcWcagReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_wcag_reset.db6561a8.svg";
export { ForwardRef as ReactComponent };